export default {
  sysMenu: {
    emailManage: "营销邮件管理",
    emailAutoPushConfig: "自动邮件配置",
    bulkEmail: "邮件群发",
    emailTemp: "模板管理",
    emailSender: "发件人管理",
    emailLog: "发送日志",
    emailUnsubscribe: "退订列表",
    emailSendRecordStats: "发送报表",
    seoPlatform: 'SEO/GEO 智能平台',
    seoPFDashboard: '概览',
    seoPFContentCenter: '内容中心',
    seoPFArticleManagement: '文章管理',
    seoPFArticleType: '文章分类',
    seoPFArticleTag: '文章标签',
    seoPFManagerTools: 'SEO/GEO 智能工具',
    seoPFKeyWordCenter: '关键词中心',
    seoPFAICreateContent: 'AI 内容生成',
    seoPFScore: 'SEO/GEO 评分',
    seoPFSiteConfig: '站点配置',
    seoPFPageModel: '页面 SEO 模板',
    seoPFSiteLink: '站内链接',
    seoPFSiteMapManagement: 'Sitemap 管理',
    seoPFDeclDoc: '站点声明文件',
    seoPFHealthCheck: 'SEO 健康检查',
    seoPFSiteBaseUrl: '站点域名配置',
    seoPFAuthor: '文章作者库',
    AIModelConfig: 'AI 模型配置',
    adsmccaccount: '广告MCC账户配置',
    adsaccount: '广告归因配置',
    adsreport: '数据报表分析',
    adsuserpushrecord: '推送记录',
    silentMember: '沉默用户列表',
    sysAdsMgmt: '广告归因管理',
    adsAgent: '代理归因绑定',
    sys: "系统设置",
    memberList: "会员列表",
    sms: "短信服務商",
    smsManage: "短信管理",
    bulkSMS: "短信群发",
    modelSMS: "短信模版",
    channelSMS: "短信营销通道",
    taskRegister: "注册未存款",
    taskSilence: "沉默用户",
    taskOff: "流失用户",
    welcomeSMS: "欢迎短信",
    restorageSMS: "存款用户",
    birthdaySMS: "生日提醒",
    taskVIP: "VIP任务",
    smsRecordStats: "短信报表",
    smsSendRecord: "短信日志",
    risk: "风险控制",
    memberRiskDimensionStats: "多维度风控预警",
    ipRiskDimensionStats: "同IP用户预警",
    deviceRiskDimensionStats: "同设备用户预警",
    bankRiskDimensionStats: "同银行卡用户预警",
    walletRiskDimensionStats: "同钱包用户预警",
    agentDailyPerformance: "今日代理数据",
    financial: "财务中心",
    bounsReport: "优惠报表",
    agentBonusStats: "代理线优惠报表",
    member: "会员中心",
    agentDailyStats: '代理每日业绩',
    agentCostStats: '推广成本',
    operation: "运营中心",
    operationsGroup: "运营中心",
    operationsBackgroundImage: "背景图管理",
    inactiveDepositors: '注册未充值列表',
    memberChurn: "用户流失列表",
    analysis: "数据分析",
    inviteFriend: "邀请好友",
    inviteFriendReport: "邀请好友报表",
    gamePlatReoprt: "游戏平台报表",
    gamePlatReoprtB: "游戏平台报表 - B",
    betRecord: "投注记录查询",
    betRecordA: "投注记录查询",
    betRecordB: "投注记录查询 - B",
    manualBalance: "会员调账记录",
    manualBalanceHistory: "调账额度变更记录",
    memberWithdrawLimit: "玩家每日提现限额",
    dashboardReport: "综合报表",
    systemConfig: "菜单设置",
    market: "市场推广",
    agentMgmt: "代理列表",
    agentTransfer: "代理线转移",
    emailconfig: "邮件账户配置",
    emailsendtempconfig: "邮件模板管理",
    sysConfigMgmt: "系统配置项管理",
    queryRole: "角色管理",
    userMgmt: "后台账号管理",
    ipWhitelist: "后台IP白名单",
    operationLog: "系统操作日志",
    webSiteConfig: "参数配置",
    lang: "多语言多币种管理",
    buttons: "按钮管理",
    menus: "菜单管理",
    curreny: "多币种管理",
    userAccountMgmt: "用户账号管理",
    activity: "优惠系统",
    freeSpinGrant: "免费旋转发放",
    gamePlatform: "游戏平台管理",
    clientInfo: "前台内容管理",
    vip: "会员等级管理",
    mall: "积分商城",
    agentTotalStats: "代理统计",
    gamePlatformMgmt: "游戏平台设置",
    gameBRoutePlatform: "B线路平台",
    activityRedemptionCodeMgmt: "兑换码管理",
    redemptionCodeMgmt: "兑换码管理",
    gameListMgmt: "子游戏设置",
    gameEntryMgmt: "首页入口管理",
    gamePromotMgmt: "主推电子游戏",
    gameHotMgmt: "热门游戏",
    gameRecMgmt: "主推游戏",
    gameTypeMgmt: "游戏类型管理",
    gameModuleMgmt: "客户端模块管理",
    desktopGameModuleMgmt: "台式机模块管理",
    activityWelfareMgmt: "领取纪录",
    activityManualSendMgmt: "批量发放",
    fsBatch: "免费旋转派发",
    activityMgmt: "优惠设置",
    activityTypeMgmt: "优惠分类管理",
    activityOperateMgmt: "特殊优惠管理",
    activityRedPacket: "红包雨",
    activityRedPacketMgmt: "红包雨管理",
    redPacketStats: "红包雨统计",
    indexBotMenu: "底部菜单管理",
    indexLtMenu: "左侧菜单管理",
    indexBanner: "首页banner图",
    indexContactUs: "联系我们",
    indexSpopup: "首页弹窗",
    indexStartAdvertising: "前台活动入口",
    gameCodeReoprt: '子游戏报表',
    gameCodeReoprtB: '子游戏报表 - B',
    betReport: '投注记录报表',
    betReportA: '投注记录报表',
    betReportB: '投注记录报表 - B',
    crossDayTransferSettlement: '跨日报转结分析看板',
    payWithdrawConfig: "充值提现配置",
    riskWithdrawConfig: "提款风控配置",
    riskAuthWithdraw: "提款风控审核",
    kyc: "kyc认证",
    kycApply: "kyc认证申请记录",
    kycCBOApply: "KYC审核记录",
    kycSUP: "完善KYC申请记录",
    blacklistQuery: "黑名单查询",
    productStok: "商品库存管理",
    productSetting: "商品设置",
    exchangeRecord: "兑换记录",
    payMethod: "支付设置",
    callBackWhiteList: "回调白名单",
    withdrawMethod: "提现设置",
    withdrawOrderList: "提现订单管理",
    payOrderList: "充值订单管理",
    paymentChannel: "支付渠道",
    withdrawType: "提现方式",
    vipExchangeMgmt: "VIP规则设置",
    vipSetupMgmt: "VIP等级设置",
    vipLogMgmt: "VIP进度查询",
    memberMgmt: "会员管理",
    memberDtail: "会员详情",
    more: "更多",
    withdrawReport: "提现报表",
    payReport: "充值报表",
    payOrderStat: "充值看板",
    withdrawOrderStat: "提现看板",
    rechargeSettlementAnalysis: "充值提款分析",
    seoPageManager: "SEO 页面管理",
    notifyManage: 'APP通知管理',
    autoPushRecord: "自动推送记录",
    autoPushConfig: "自动推送配置",
    autoPushStats: "自动推送统计",
    manualPushRecord: "手动推送记录",
    agentTag: "代理标签",
    agentType: "代理类型",
    manualPushConfig: "手动实时推送",
    manualPushReport: "手动推送统计",
    kycconfig: "kyc配置",
    riskWithdrawConfigGroup: "提款风控配置",
    riskWithdrawConfigPhp: "PHP 币种配置",
    riskWithdrawConfigVnd: "VND 币种配置",
    riskWithdrawConfigCny: "CNY 币种配置",
    riskWithdrawConfigUsd: "USD 币种配置",
    riskWithdrawConfigMxn: "MXN 币种配置",
    paramConfigGroup: "参数配置",
    paramAccountAuth: "账户与认证",
    paramSecurityRisk: "安全与风控",
    paramThirdPartyService: "第三方服务",
    paramAppMgmt: "App管理",
    paramBizRule: "业务规则与系统参数",
    paramResourceDisplay: "资源管理",
    paramReportConfig: "监管上报配置",
    paramRouteStrategy: "游戏线路策略配置",
    messageNotify: "消息与通知",
    payWithdrawConfigGroup: "充值提现配置",
    withdrawBaseConfig: "提款基本配置",
    withdrawAccountBindConfig: "提款账号绑定配置",
    kycConfigGroup: "KYC 配置",
    kycGlobalConfig: "KYC 全局配置",
    kycNormalScene: "普通用户 KYC 场景",
    kycAgentScene: "代理用户 KYC 场景",
    kycFailRule: "KYC 失败处理规则",
    registrationConversion: "注册与转换报表",
    userRegisterDistribution: "注册用户面板",
    activeUserDistribution: "活跃用户面板",
    onlineUserDistribution: "在线用户面板",
    valueStats: "价值报表",
    keepStats: "存款留存报表",
    betKeepStats: "投注留存报表",
    overviewStats: "总览报表",
    userAnalysis: "用户分析",
    memberLoginLog: "会员登录日志",
    memberLoginLogReport: "基本信息",
    memberLoginLogSummary: "总览报表",
    luckySpin: "大转盘管理",
    luckySpinTicketMgmt: "参与券设置",
    luckySpinGrantTicketLog: "派发记录",
    luckySpinLog: "使用记录",
    auditReport: "审计报表",
    auditSummary: "汇总报表",
    auditGameType: "游戏类型报表",
    auditBranchGameType: "分店游戏类型报表",
    auditProvider: "供应商报表",
    auditProviderGameType: "供应商游戏类型报表",
    auditGameOrder: "注单查询",
    auditPlayerCount: "玩家数量报表",
    auditPlayerAggregator: "玩家汇总报表",
    auditCloseReportUser: "关闭上报用户列表",
    closeReportUser: "游戏线路变更记录",
    activeMember: "活跃用户列表",
    depositMemberList: "存款用户列表",
    vipMemberList: "VIP用户列表",
    newsManagement: "文章管理",
    newsListMgmt: "文章列表",
    newsCategoryMgmt: "文章分类",
    newsTagMgmt: "文章标签",
    newsInternalLinkMgmt: "内链关键词",
    newsCategory: "文章分类",
    newsTag: "文章标签",
    newsArticle: "文章列表",
    inboxMessage:"站内信管理",
    sendInboxMessage:"手动站内信记录",
    autoInboxMannulConfig: "手动站内信发送",
    autoInboxMessageConfig: "自动站内信配置",
    autoInboxMessage: "自动站内信记录",
    mannuInboxStats: "手动站内信统计",
    autoInboxStats: "自动站内信统计",
    userLeaderboard: "用户排名",
    depositLeaderboard: "存款榜",
    withdrawLeaderboard: "取款榜",
    promotionLeaderboard: "优惠榜",
    winLeaderboard: "赢钱榜",
    lossLeaderboard: "输钱榜",
    betLeaderboard: "投注榜",
    gameRanking: "游戏排行榜",
    leaderboardActivity: "排行榜活动",
    leaderboardActivityActivityList: "活动列表",
    leaderboardActivityBoardRecords: "榜单记录",
    leaderboardActivityAwardRecords: "发奖记录",
    importLog: "导入操作管理",
    inviterList: "邀请好友列表",
    jeepneyUserList: "裂变用户查询",
    rebateList: "返佣记录",
    negativeProfitMember: "负盈利用户列表",
    tagMgmt: "标签管理",
    manualTag: "手动标签",
    autoTag: "自动标签",
    chickActivity: "签到与活跃活动",
    chickActivityMgmt: "活动配置",
    chickActivityReport: "数据报表",
    chickActivityUserStats: "用户状态查询",
    jeepneyActivity: "裂变活动",
    jeepneyActivityMgmt: "裂变活动配置",
    jeepneyBlockRewardMgmt: "赛道与奖励设置",
    jeepneySettlementMgmt: "结算设置",
    jeepneyFunnelAnalysis: "裂变漏斗分析",
    treasureBox: "宝箱管理",
    treasureBoxMgmt: "宝箱管理",
    treasureBoxConfig: "宝箱设置",
    treasureBoxStats: "宝箱统计",
    treasureBoxRecords: "宝箱派发记录",
    treasureBoxRecord: "宝箱派发记录",
    report: "财务报表",
  },
  // 按钮名称：key 为语言中立的 buttonCode（platformButton.buttonCode），
  // 查无 key 时页面回退显示 DB 中存的 buttonName（运营自建按钮）
  sysButton: {
    "accountInfo-BankCardStatus": "会员详情-账户信息-银行卡启用/禁用",
    "accountInfo-BankCardUnbind": "会员详情-账户信息-银行卡绑定/解绑",
    "accountInfo-FlowManualAdjust": "会员详情-账户信息-流水手动调账",
    "accountInfo-WalletManualAdjust": "会员详情-账户信息-钱包手动调账",
    "accountInfo-WalletStatus": "会员详情-账户信息-钱包启用/禁用",
    "accountInfo-WalletTakeBack": "会员详情-账户信息-钱包取回",
    "accountInfo-WalletUnbind": "会员详情-账户信息-钱包绑定/解绑",
    "accountInfo-manualAdjustPoint": "会员详情-账户积分-人工调整积分",
    adminRiskUnLock: "管理员提款风控解锁",
    adminRiskView: "管理员提款风控搜索",
    "batchDistribution-Participation": "批量发放-参与券",
    "batchDistribution-cash": "批量发放-现金",
    "batchDistribution-integral": "批量发放-积分",
    "chargeOrderManager-comfirmOrder": "充值订单管理-确认订单",
    "chargeOrderManager-export": "充值订单管理-导出",
    "exchangeRecord-export": "兑换记录-导出",
    "manualBalance-export": "会员调账记录导出",
    "manualBalanceHistory-export": "導出",
    "memberInfo-AgentName": "会员详情-基本信息-上级代理",
    "memberInfo-Email": "会员详情-基本信息-邮箱",
    "memberInfo-Identity": "会员详情-基本信息-身份信息",
    "memberInfo-Phone": "会员详情-基本信息-手机号码",
    "memberInfo-RegulatoryReportClose": "会员详情-关闭数据上报",
    "memberInfo-RegulatoryReportTab": "会员详情-游戏线路状态Tab",
    "memberInfo-Remark": "会员详情-基本信息-备注",
    "memberInfo-ResetPassword": "会员详情-基本信息-重置登录密码",
    "memberInfo-ResetWithdrawPassword": "会员详情-基本信息-重置提现密码",
    "memberInfo-WithdrawLimit": "会员详情-基本信息-提现限额",
    "memberWithdrawLimit-edit": "玩家每日提现限额-编辑",
    "memberInfo-RiskLevel": "会员详情-基本信息-风险控制",
    "memberInfo-UserTypeSetting": "用户类型设置",
    "memberInfo-View-Phone": "会员详情-基本信息-查看手机号码",
    "memberInfo-export": "会员数据导出",
    "memberInfo-kyc-edit": "提款kyc-修改",
    "memberInfo-upload": "会员数据上传",
    "memberchurn-export": "用户流失列表-导出",
    "memberchurn-query": "用户流失列表-查詢",
    "memberkycinfo-batchSetFail": "kyc认证申请记录-批量置为失败",
    "memberkycinfo-batchSetSuccess": "kyc认证申请记录-批量置为成功",
    "memberkycinfo-docmentData": "kyc信息修改-证件",
    "memberkycinfo-historicalData": "kyc认证申请记录-历史数据",
    "memberkycinfo-idCard": "kyc认证申请记录-身份证件",
    "memberkycinfo-setFail": "kyc认证申请记录-置为失败",
    "memberkycinfo-setSuccess": "kyc认证申请记录-置为成功",
    "membernorecharge-export": "注册未充值列表-导出",
    "membernorecharge-query": "注册未充值列表-查詢",
    "newsArticle-add": "文章管理列表-新增文章",
    "newsArticle-approve": "文章管理列表-审核通过",
    "newsArticle-delete": "文章管理列表-删除",
    "newsArticle-edit": "文章管理列表-编辑",
    "newsArticle-reject": "文章管理列表-拒绝",
    "newsArticle-seo-edit": "文章管理列表-SEO编辑",
    opUserAdjustQuota: "额度管理",
    opUserDelete: "删除",
    opUserDisable: "禁用",
    opUserEdit: "编辑",
    opUserModifyRole: "修改角色",
    opUserResetGoogleAuth: "重置谷歌验证码",
    opUserResetLoginPassword: "重置登录密码",
    "email-log-export": "发送日志-导出",
    "sms-log-export": "短信日志-失败名单导出",
    "withdrawOrderList-adminUnLock": "提现订单管理-管理员解锁",
    "withdrawOrderList-confirmWithdrawal": "提现订单管理-确认出款",
    "withdrawOrderList-export": "提现订单管理-导出",
    "withdrawOrderList-refusedWithdrawal": "提现订单管理-拒绝提现",
    "withdrawOrderList-reject": "提现订单管理-拒绝",
    "withdrawOrderList-replaceWithdrawal": "提现订单管理-代付出款"
  },
  menu: {
    add: "新增",
    edit: "编辑",
    menu: "菜单",
    parentMenu: "父菜单节点",
    selectParentMenu: "选择父菜单节点",
    menuLevel: "菜单等级",
    selectMenuLevel: "请选择菜单等级",
    menuCode: "菜单Code",
    menuName: "菜单名称",
    isLeaf: "是否是叶子节点",
    yes: "是",
    no: "否",
    menuUrl: "访问后台的url地址",
    enterMenuUrl: "请输入访问后台的url地址",
    menuOrder: "菜单顺序"
  },
  tagView: {
    closeCurrent: "关闭当前",
    closeOthers: "关闭其他",
    closeAll: "关闭全部",
    home: "首页"
  },
  avatar: {
    personalCenter: "个人中心",
    changePassword: "变更密码",
    logout: "退出登录"
  },
}
